export enum TipoMovimientoFacturaAnticipada {
  Recarga,
  Consumo,
  Devolucion,
  SaldoAnterior
}
